import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const SummaryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${p => (p.$alignLeft ? 'flex-start' : 'center')};
  justify-content: center;
  width: 100%;
  min-height: 4rem;
  font-size: 1.4rem;
`;

export const SummaryText = styled.span`
  font-weight: bold;
`;

export const LinkButton = styled.button`
  background: transparent;
  border: 0;
  padding: 0;
  color: ${p => p.theme.secondaryColor};
  text-decoration: underline;
  cursor: ${p => (p.disabled ? 'default' : 'pointer')};
  opacity: ${p => (p.disabled ? 0.6 : 1)};
  font-size: 1.3rem;
`;

export const DetailsWrapper = styled.div`
  width: 100%;
  padding: 0 2rem 1.5rem 11rem;
  font-size: 1.3rem;
  color: ${p => p.theme.textColor};
  ${media.smaller`
    padding: 0 2rem 1.5rem 2rem;
  `};
`;

export const DetailsHeading = styled.div`
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

export const BoxRows = styled.ul`
  list-style: none;
  margin: 0 0 1rem;
  padding: 0;
`;

export const BoxRowItem = styled.li`
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 1rem;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: ${p => `solid 0.1rem ${p.theme.secondaryBgColor}`};
  ${media.smaller`
    grid-template-columns: 1fr auto;
  `};
`;

export const BoxNumberText = styled.span`
  opacity: 0.7;
  ${media.smaller`
    display: none;
  `};
`;

export const Notice = styled.div`
  margin-bottom: 1rem;
  color: ${p => p.theme.tertiaryAltColor};
`;

export const EstimatedTag = styled.span`
  display: block;
  font-size: 1.1rem;
  font-weight: normal;
`;
